"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgMoneyCircle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgMoneyCircle = function SvgMoneyCircle(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm1.094-10.228c.24.25.36.588.36 1.015 0 .412-.134.74-.4.985-.265.24-.627.36-1.085.36-.552 0-.977-.165-1.274-.493-.291-.333-.437-.81-.437-1.43H8c0 1.068.292 1.925.875 2.57.589.641 1.417 1.019 2.484 1.134v1.546h1.243v-1.554c.968-.1 1.729-.425 2.28-.977.553-.552.829-1.27.829-2.156 0-.474-.073-.888-.219-1.242a2.852 2.852 0 00-.633-.954 4.289 4.289 0 00-1.015-.75 13.54 13.54 0 00-1.54-.71c-.62-.25-1.044-.495-1.273-.735-.229-.24-.344-.557-.344-.953 0-.427.118-.76.352-1 .234-.245.565-.367.992-.367.432 0 .776.156 1.031.469.26.307.391.773.391 1.398h2.258c0-1.016-.26-1.841-.781-2.476-.521-.641-1.242-1.026-2.164-1.157V4.6h-1.25v1.672c-.933.094-1.68.422-2.243.984-.562.563-.843 1.284-.843 2.164 0 .51.08.95.242 1.32.167.37.396.693.687.97.297.27.651.512 1.063.726.411.208.9.42 1.469.633.567.213.968.448 1.203.703z"
  }));
};

exports.SvgMoneyCircle = SvgMoneyCircle;
SvgMoneyCircle.isIcon = true;
SvgMoneyCircle.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgMoneyCircle;
exports["default"] = _default;